fx.ns("shared.popups", class FileUploaded extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personAdvice );

        this.contentWidth = 550;
        this.contentHeight = 215;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:fx.text("Votre fichier est en cours d'import"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("Je vous préviens dès que votre fichier est prêt à être utilisé."), className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onClose, this.closeBtn);
    }

});